export interface AppConfig {
  production: boolean;
  shops: {
    api: { baseUrl: string };
    web: { baseUrl: string };
    cdn: { baseUrl: string };
  };
  kamaleon: {
    api: { baseUrl: string };
  };
  redsys: {
    paygoldUrl: string;
  };
  restcountries: {
    baseUrlTranslations: string;
    apikey: string;
  };
}

let _config: AppConfig | null = null;

export async function loadAppConfig(): Promise<AppConfig> {
  const res = await fetch('/assets/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Failed to load /assets/config.json: ${res.status} ${res.statusText}`);
  }
  _config = (await res.json()) as AppConfig;
  return _config;
}

export function getAppConfig(): AppConfig {
  if (!_config) {
    throw new Error('AppConfig not loaded. loadAppConfig() must be awaited before bootstrapModule().');
  }
  return _config;
}
